// Marca RAIZ — broto sobre raiz estilizada.

export const RaizLogo = ({ size = 32 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" role="img" aria-label="RAIZ">
    <rect width="32" height="32" rx="7" fill="#0B7A4B" />
    <path d="M16 6c0 4-2.5 6.5-2.5 10S16 26 16 26s2.5-6 2.5-10S16 10 16 6z" fill="#fff" opacity="0.95" />
    <path
      d="M16 14c-2-2.5-5-3-7.5-2.5 1 2.8 3.5 4.6 7 4.6M16 18c2-2.5 5-3 7.5-2.5-1 2.8-3.5 4.6-7 4.6"
      stroke="#fff"
      strokeWidth="1.8"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
)
